@if (validFrom()) {
  <span class="text-nowrap">
    <lucide-icon [img]="icons.since"></lucide-icon>
    <span class="ms-1" [class.text-danger]="isNotYetValid() && highlight()">{{ validFrom() }}</span>
  </span>
}
@if (validUntil()) {
  <span class="text-nowrap">
    <lucide-icon [img]="icons.until"></lucide-icon>
    <span class="ms-1" [class.text-danger]="isExpiringSoon() && highlight()">{{ validUntil() }}</span>
  </span>
}
